export default "__VITE_ASSET__Cqv334WB__"